import { is } from '@common/is/is'

import type { TBaseVersion, TVersionRestrictionVariation } from '../definitions'

import getRelation                    from './getRelation'
import parseRestrictionValue          from './parseRestrictionValue'
import isRestrictedBySplittedVersions from './isRestrictedBySplittedVersions'

/**
 * Korlátozzuk a verziószám alapján?
 * @param variation - Korlátozás.
 * @param version   - Verziószám.
 */
export default function isRestrictedByVariation (
  variation: TVersionRestrictionVariation,
  version: TBaseVersion
): boolean {
  if (!is.string(version)) {
    return false
  }

  const sign = getRelation(variation)

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  const restrictionVersion = variation.slice(2)

  const parsedRestrictionVersion = parseRestrictionValue(restrictionVersion)
  const parsedVersion            = parseRestrictionValue(version)

  if (typeof parsedVersion !== typeof parsedRestrictionVersion) {
    return false
  }

  if (is.string(parsedRestrictionVersion) || is.string(parsedVersion)) {
    if (sign === '=') {
      return parsedVersion === parsedRestrictionVersion
    }

    return false
  }

  const isRestricted = isRestrictedBySplittedVersions(
    parsedVersion, parsedRestrictionVersion, sign
  )

  return isRestricted
}
